import { AG_GRID_LOCALE_DE, AG_GRID_LOCALE_ES, AG_GRID_LOCALE_FR, AG_GRID_LOCALE_NL, AG_GRID_LOCALE_PT } from '@ag-grid-community/locale';
import { iframeDataBridge } from '../iframe/iframeDataBridge';

const AG_GRID_LOCALES = {
	de: AG_GRID_LOCALE_DE,
	'de-de': AG_GRID_LOCALE_DE,
	es: AG_GRID_LOCALE_ES,
	'es-es': AG_GRID_LOCALE_ES,
	en: undefined,
	'en-gb': undefined,
	fr: AG_GRID_LOCALE_FR,
	'fr-fr': AG_GRID_LOCALE_FR,
	nl: AG_GRID_LOCALE_NL,
	'nl-nl': AG_GRID_LOCALE_NL,
	pt: AG_GRID_LOCALE_PT,
	'pt-pt': AG_GRID_LOCALE_PT,
};

function normalizeLocale(locale) {
	return (locale || '').toString().trim().toLowerCase();
}

export function getCurrentAppLocale() {
	const externis = iframeDataBridge.getExternis(false);
	return externis.ctx.user.locale || 'fr-FR';
}

export function getAgGridLocaleText(locale = getCurrentAppLocale()) {
	const normalizedLocale = normalizeLocale(locale);

	if (Object.prototype.hasOwnProperty.call(AG_GRID_LOCALES, normalizedLocale)) {
		return AG_GRID_LOCALES[normalizedLocale];
	}

	const language = normalizedLocale.split('-')[0];
	if (Object.prototype.hasOwnProperty.call(AG_GRID_LOCALES, language)) {
		return AG_GRID_LOCALES[language];
	}

	return AG_GRID_LOCALE_FR;
}
